import { Box } from '@mui/material';
import { WizardTextField } from './WizardTextField';
import { WizardAutocompleteField } from './WizardAutocompleteField';
import { WizardFileField } from './WizardFileField';
import CampaignLinkRender from './CampaignLinkRender';

interface AutoCreateCampaignFormProps {
  entryDomains: any[];
  offerGroups: any[];
}

function AutoCreateCampaignForm({ entryDomains, offerGroups }: AutoCreateCampaignFormProps) {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, ml: 4 }}>
      <WizardTextField label="Campaign Name" name="campaignName" helperText="Default: [Offer Name] Campaign" />

      <WizardAutocompleteField
        label="Entry Domain"
        name="campaignEntryDomainId"
        options={entryDomains.map((domain) => ({
          id: domain._id,
          label: domain.domainName,
        }))}
      />

      <CampaignLinkRender />

      <WizardAutocompleteField
        label="Report to Offer Group"
        name="offerGroupId"
        options={offerGroups.map((group) => ({
          id: group._id,
          label: group.label,
        }))}
        helperText="Remember to add the offer in the offer group to display it in the relationships API"
      />

      <WizardFileField label="Iron Dome CSV (Optional)" name="campaignIronDomeFile" helperText="Upload a CSV file for Iron Dome integration" />
    </Box>
  );
}

export default AutoCreateCampaignForm;
